module.exports = __webpack_public_path__ + "images/email/bg-active-3-0b9b712e1014d4b002aa9c50e1c9cbe7.png";